module.exports = "../study/imgs/maps/Kanagawa/S8/Agriculture/RiceQ/Kanagawa_RiceQ_GFDL_RCP85_End.png";